import "./App.css";
import { Navigate, Outlet, RouterProvider, createBrowserRouter, useLocation, useMatches } from "react-router-dom";
import { Suspense, useEffect } from "react";
import LoadingBackdrop from "../Components/LoadingBackdrop/LoadingBackdrop";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { theme } from "../Resources/Design/theme";
import { HelmetProvider } from "react-helmet-async";
import baseRoutes from "./routes";
import ErrorLogger from "../Pages/ErrorPage/ErrorLogger";
import ErrorRouteLogger from "../Pages/ErrorPage/ErrorRouteLogger";
import { SiteProvider } from "../Firebase/SiteProvider";
import Navbar from "../Components/Navbar";
import ScrollUp from "../Components/ScrollUp";
import BaseFooter from "../Components/BaseFooter";
import CookieBar from "../Components/CookieBar";
import { AuthProvider, useAuth } from "../Firebase/AuthProvider";
import AdminPanel from "./AdminPanel";
import { FirestoreProvider, useFirestore } from "../Firebase/FirestoreProvider";
import { DialogManager } from "./DialogManager";
import { storage } from "../Firebase/firebase_init";
import Helmet from "./Helmet/Helmet";
import { OpenProvider } from "../Components/OpenProvider";
import FabPhone from "../Components/FabPhone";
import { PriceDialogManager } from "./PriceDialogManager";

const adminPaths = ['/preview'];

async function loadFontsFromFirebase() {
  /*const url = await getDownloadURL(ref(storage, ''));

  const font = new FontFace(fontName, `url(${url})`);
  await font.load();

  document.fonts.add(font);
  document.body.style.fontFamily = fontName;*/
}

function RouteProviders({ ...props }) {

  return (
    <>
      <ErrorRouteLogger>
        <ErrorLogger>
          <DialogManager>
            <PriceDialogManager>
              <FirestoreProvider>
                <OpenProvider>
                  <AuthProvider>
                    <RouteControl {...props} />
                  </AuthProvider>
                </OpenProvider>
              </FirestoreProvider>
            </PriceDialogManager>
          </DialogManager>
        </ErrorLogger>
      </ErrorRouteLogger>
    </>
  );
}

const isAdminPath = () => {
  const hostname = window.location.hostname;
  return hostname.startsWith("admin.") || hostname.startsWith("primestsky-tabor--admin");
}

function RouteControl({ ...props }) {
  const { isAdmin = false, authLoading } = useAuth();
  const matches = useMatches();
  const location = useLocation();

  const current = matches[matches.length - 1];
  const handle = current?.handle || {};
  const { navbar = {}, hideNavbar = false } = handle;


  if (!authLoading) {
    if (isAdminPath() && !isAdmin && location.pathname !== '/login') {
      return <Navigate to='/login' />
    }
    if (!isAdminPath() && location.pathname === '/login') {
      return <Navigate to='/' />
    }
    if (isAdmin && isAdminPath() && location.pathname === '/login') {
      return <Navigate to='/' />
    }
    if (adminPaths.includes(location?.pathname) && !isAdmin) {
      return <Navigate to='/login' />
    }
  }

  return (
    <>
      <ScrollUp />
      <Helmet>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          {isAdmin && <AdminPanel />}
          <div className="App" style={{
            minWidth: '340px', overflowX: 'hidden',
            ...(isAdmin && { paddingTop: '80px' })
          }}>
            {!hideNavbar && <Navbar {...navbar} isAdmin={isAdmin} />}
            <main style={{ minHeight: '100vh' }}>
              <Outlet context={props} />
            </main>
            <BaseFooter />
            <CookieBar />
          </div>
        </ThemeProvider>
      </Helmet>
    </>

  );
}

const router = createBrowserRouter([
  {
    element: <RouteProviders />,
    errorElement: <ErrorRouteLogger />,
    children: baseRoutes,
  },
]);

function App() {
  return (

    <Suspense fallback={<LoadingBackdrop open={true} />}>
      <HelmetProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </HelmetProvider>
    </Suspense>

  );
}

export default App;
